import { render, staticRenderFns } from "./PersonAdd.vue?vue&type=template&id=2e8a5f1e&scoped=true"
import script from "./PersonAdd.vue?vue&type=script&lang=js"
export * from "./PersonAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8a5f1e",
  null
  
)

export default component.exports